import { render, staticRenderFns } from "./teamhis.vue?vue&type=template&id=ef48ea38&scoped=true"
import script from "./teamhis.vue?vue&type=script&lang=js"
export * from "./teamhis.vue?vue&type=script&lang=js"
import style0 from "./teamhis.vue?vue&type=style&index=0&id=ef48ea38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef48ea38",
  null
  
)

export default component.exports